<template id="main-page">
  <v-ons-page>
    <v-ons-toolbar>
      <div class="center">Orçamentos</div>
    </v-ons-toolbar>
        <p style="text-align: center;padding: 3%; font-size:95%; font-weight:bold">
        <v-ons-search-input v-model="nome" placeholder="Filtrar"/>
         <select class="select-input select-input--material" style="width: 100%;" v-model="stat" aria-describedby="frete">
                      <option value="0">Todos</option>
                      <option value="2">Aguardando aprovação Comercial</option>
                      <option value="4">Aprovado comercial</option>
                      <option value="6">Aguardando aprovação financeira</option>
                      <option value="7">Em processo</option>
                      <option value="8">Parcialmente faturado</option>
                      <option value="9">Faturado Total</option>
        </select>
        </p>
     <v-ons-card>
    <div class="content">
    <v-ons-list>
        <ons-gesture-detector>
        <v-ons-list-item v-for="item of filterorcamentos" :key="item.nrpedido" @click="Action(item.nrpedido, item.status)">
        <!--<div class="center"> -->
        <v-ons-row>
        <v-ons-col width="30%" style="padding-right:2%;">
            <p style="color: red" v-if="item.status == 1">Orçamento salvo </p>  
            <p v-if="item.status == 2">Em aprovação comercial </p> 
            <p v-if="item.status == 3">Em aprovação comercial (Extra) </p> 
            <p v-if="item.status == 4">Aprovado comercial </p> 
        </v-ons-col>
        <v-ons-col width="70%">
            {{item.rsocial}}   <br>
            {{item.nrpedido}}  <br>
            {{item.oc}}        <br>
            {{item.dataImplant.substring(0,2) + "/" + item.dataImplant.substring(2,4) + "/" + item.dataImplant.substring(4,8)}}
        </v-ons-col>
        <!--</div>-->
        <!--<div class="left" style="padding: 3%;"> -->
        </v-ons-row>
        <!--</div> -->
        </v-ons-list-item>

        </ons-gesture-detector>   
  </v-ons-list>
</div>
 </v-ons-card>
     <v-ons-action-sheet :visible.sync="actionSheetVisible" cancelable>
      <v-ons-action-sheet-button icon="md-check" @click="$ons.notification.confirm({
            message: 'Deseja transformar orçamento em pedido?',
            title: 'ATENÇÃO',
            buttonLabels: ['Cancelar', 'Confirmar'],
            animation: 'default',
            primaryButtonIndex: 1,
            cancelable: true,    callback: function (index) {
             if (index == 1) {confirm()}
             actionSheetVisible = false
             }})">Transformar em pedido</v-ons-action-sheet-button>
    <v-ons-action-sheet-button icon="md-brush" @click="alterar()">Alterar Orçamento</v-ons-action-sheet-button>
    <v-ons-action-sheet-button icon="md-close" @click="dismiss()">Cancelar</v-ons-action-sheet-button>
    </v-ons-action-sheet>

     <v-ons-action-sheet :visible.sync="actionSheetVisible1" cancelable>
    <v-ons-action-sheet-button icon="md-brush" @click="detalhes()">Detalhar</v-ons-action-sheet-button>
    <v-ons-action-sheet-button icon="md-close" @click="dismiss()">Cancelar</v-ons-action-sheet-button>
    </v-ons-action-sheet>
  </v-ons-page>
</template>

<style>
  /* CSS goes here */
</style>

<script>
import { mapGetters } from 'vuex'
import store from '../store/index.js'
import local from '../services/sql.js'
import erp from '../services/erp.js'

export default {

  data(){
    return {
      orcamentos: [],
      nome: '',
      cliId: '',
      listOrc: [],
      fullName: '',
      stat: '0',
      status: '',
      nrpedido: '',
      actionSheetVisible: false,
      actionSheetVisible1: false,
      timeoutID: 0
       }
  },
  mounted(){
	this.carregar()
	},
  name: 'Users',
  computed: mapGetters([
    'isAdmin',
  ]),
  computed: {
    filterorcamentos: function() {

      const lNome = this.nome.toLowerCase()

      if (this.stat == 0) {      
      return this.listOrc.filter((orcamento) => {
        return orcamento.nrpedido.toLowerCase().match(lNome) || orcamento.oc.toLowerCase().match(lNome) || orcamento.cgc.toLowerCase().match(lNome) || orcamento.rsocial.toLowerCase().match(lNome)
      })
      }
      else {     
      return this.listOrc.filter((orcamento) => {
        return orcamento.nrpedido.toLowerCase().match(lNome) || orcamento.oc.toLowerCase().match(lNome) || orcamento.cgc.toLowerCase().match(lNome)  || orcamento.rsocial.toLowerCase().match(lNome) && orcamento.status == this.stat
      })
      }
    },
    },
    methods: {
	  carregar: async function() {
	    await local.getOrcamentoRepres({data: this.$store.getters.getCodrep}).then(resposta => {
            this.orcamentos = resposta.data
    })
    	    this.orcamentos.forEach(k => {
				erp.detalhe(k.cgc).then(resp => {
				this.listOrc.push({
				dataImplant: k.dataImplant,
				nrpedido: k.nrpedido,
				status: k.status,
				cgc: k.cgc,
				oc: k.oc,
                rsocial: resp.data['nome-emit'],
				})
				})
			})
  	},
	Action(nrpedido, status) { 
          this.nrpedido = nrpedido
          this.status = status

          if (status == 1) {
            this.actionSheetVisible = true
          }
          else {
            this.actionSheetVisible1 = true
          }
    },
    alterar: function () {
        this.$router.push('/orcamento/' + this.nrpedido + '/2')
      },
    detalhes: function () {
        this.$router.push('/orcamento/' + this.nrpedido + '/3')
      },
      orcamento: function (e) {
        this.$router.push('/orcamento/' + e)
      },
      async confirm(){
		this.listOrc = []		
        await local.confOrcamento({data: this.nrpedido})
		this.carregar()
      },
      dismiss(){
        this.actionSheetVisible = false
        this.actionSheetVisible1 = false
      }
    }


  }
</script>